
import NavBarButtonLink from './NavBarButtonLink.vue'

export default {
  name: 'NavBarButton',
  components: {
    NavBarButtonLink,
  },
  props: {
    link: {
      type: [Object, Array],
      default() {},
    },
    isOpened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChildLinksOpen: false,
    }
  },
  watch: {
    isOpened() {
      if (!this.isOpened) {
        this.isChildLinksOpen = false
      }
    },
  },
  methods: {
    toggleChildLinks() {
      if (!this.isOpened) {
        this.$store.commit('navbar/openNavBar')
      }
      this.isChildLinksOpen = !this.isChildLinksOpen
    },
    closeNavBar() {
      this.$emit('clicked', this.link.modalTurmas)
    },
  },
}
